import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';
import { flexCenter } from '../common-styles';

type ImageActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const ImageAction = ({ compact = true, showBoxShadow = true, ...rest }: ImageActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='em' weight='bold' className={flexCenter}>
        <Icon name='image-small' />
      </Text>
    </ActionPressedChip>
  );
};
